import { FulfillmentGroupStatus } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const listUnpickedOrders = {
  name: "listUnpickedOrders" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    productId: productIdFormat.schema,
  }),
  output: z.object({
    orders: z.array(
      z.object({
        fulfillmentGroupId: z.string(),
        orderName: z.string().nullable(),
        orderLinkId: z.string().nullable(),
        isRedoOrder: z.boolean(),
        unpicked: z.number(),
        status: createEnum(FulfillmentGroupStatus).nullable(),
      }),
    ),
    unpickedTotal: z.number(),
  }),
};
